import React from "react";
import {eventService} from "../../jwt/_services/core/eventService";

export const eventProvider = {
    getOptions
}

async function getOptions(customFilter) {
    try {
        const response = await eventService.getOptions( customFilter );

        return response.data.map((item) => {
            return (
                {
                    id: item.id,
                    value: item.code + '-' + item.title,
                    label: <label>{ item.code?.toUpperCase() + ' - '  } <b>{ item.title }</b> </label>
                }
            )
        });
    } catch (error) {
        console.log(error.message)
    }
}